<template>
    <section class="AiraPagination" :class="{'AiraPagination--small': isSmall}">
        <div class="AiraPagination__Info" v-if="!noPages">
            <span>
                {{$t('pagination.messages.message_total', { 
                    "from" : pagination.from?pagination.from:0,
                    'to' : pagination.to?pagination.to:0,
                    'total' : pagination.total,
                    'message': message
                })}}
            </span>
        </div>
        <div class="AiraPagination__container">
            <a  
                :class="`AiraPagination__previous 
                        ${!pagination.prev && 'AiraPagination__previous--disabled'}`"
                @click="previousPage">
            {{$t('pagination.options.previous')}}</a>
            <span class="AiraPagination__containerNumbers" v-if="!noPages">
                <template>
                    <a 
                        :class="`AiraPagination__number ${pagination.current_page == 1 && ('AiraPagination__number--current')}`" 
                        @click="changeSelectedPage(1)">
                        1
                    </a>
                    <span v-if="pagination.current_page > (SHOW_PAGES - 1) && pagination.last_page > (SHOW_PAGES + 1)">…</span>
                </template>
                <a 
                :class="`AiraPagination__number ${pagination.current_page == value && ('AiraPagination__number--current')}`" 
                @click="changeSelectedPage(value)"
                v-for="value in paginationList" :key="value">
                    {{value}}
                </a>   
                 <template v-if="pagination.last_page > SHOW_PAGES">
                    <span v-if="pagination.current_page <= (pagination.last_page - (SHOW_PAGES - 1)) && pagination.last_page > (SHOW_PAGES + 1)">…</span>
                    <a
                    :class="`AiraPagination__number ${pagination.current_page == pagination.last_page && ('AiraPagination__number--current')}`" 
                    @click="changeSelectedPage(pagination.last_page )">
                        {{pagination.last_page }}
                    </a> 
                 </template>
            </span>
            <a :class="`AiraPagination__next 
                        ${!pagination.next && 'AiraPagination__previous--disabled'}`"
                @click="nextPage">{{$t('pagination.options.next')}}</a>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        pagination: Object,
        message: String,
        isSmall: {
            type: Boolean,
            default: false
        },
        noPages: {
            type: Boolean,
            default: false
        }
    },
    name: "Pagination",
    data() {
        return {
            SHOW_PAGES: 5,
        }
    },
    computed: {
        paginationList(){
            let list = []
            if (this.pagination.current_page < this.SHOW_PAGES || this.pagination.last_page <= this.SHOW_PAGES) {
                for (let index = 2; index <= ( this.SHOW_PAGES <  this.pagination.last_page ? 
                    this.SHOW_PAGES : this.pagination.last_page); index++) {
                    list.push(index);
                }
                return list;
            } else if (this.pagination.current_page <= this.pagination.last_page - (this.SHOW_PAGES - 1 )) {
                list = [this.pagination.current_page - 1, 
                            this.pagination.current_page, 
                            this.pagination.current_page + 1];
                return list;
            } else {
                for (let index = (this.pagination.last_page - 1 ); index > this.pagination.last_page - this.SHOW_PAGES; index--) {
                    list.unshift(index);
                }
                return list;
            }
        }
    },
    methods: {
        nextPage() {
            this.$emit("changePage", this.pagination.current_page + 1)
        },
        previousPage(){
            this.$emit("changePage", this.pagination.current_page - 1)
        },
        changeSelectedPage(index) {
            this.$emit("changePage", index)
        }
    } 
}
</script>